var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sys-teacher-hub-modal',{attrs:{"show":_vm.show,"title":_vm.title,"icon":"mdi-clock-outline"},on:{"update:show":function($event){return _vm.$emit('update:show', $event)}}},[_c('v-card-text',{staticClass:"pa-4"},[_c('sys-teacher-confirmed-times',{attrs:{"teacher":_vm.teacher,"work-time":_vm.workTime,"token":_vm.token}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }